import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";



function MathSection() {
  // creates math section and adds questions to it.
  return (
    <div className="row section my-5" id="maths-section">
      <h2>Maths</h2>
      {
        [...Array(50)].map((qn, i) => <Question
          section={'m'}
          count={i + 1}
          subject={'maths'}
        />)
      }
    </div>
  );
}

function LogicalSection() {
  // creates logical section and adds questions to it.
  return (
    <div className="row section my-5" id="logical-section">
      <h2>Logical Reasoning</h2>
      {
        [...Array(40)].map((qn, i) => <Question
          section={'l'}
          count={i + 1}
          subject={'logical'}
        />)
      }
    </div>
  );
}

function ComputerSection() {
  // creates computer section and adds questions to it.
  return (
    <div className="row section my-5" id="comp-section">
      <h2>Computer</h2>
      {
        [...Array(10)].map((qn, i) => <Question
          section={'c'}
          count={i + 1}
          subject={'computer'}
        />)
      }
    </div>
  );
}

function EnglishSection() {
  // creates english section and adds questions to it.
  return (
    <div className="row section mt-5" id="eng-section">
      <h2>English</h2>
      {
        [...Array(20)].map((qn, i) => <Question
          section={'e'}
          count={i + 1}
          subject={'english'}
        />
        )
      }
    </div>
  );
}


function Question(props) {
  // Creates question of desired section
  // Props:
  //   count: has numbers from 1 to 50
  //   section: m (Maths), l (Logical), c (Computer), e (English)
  //   subject: maths, logical, computer, english

  return (

    <div id={`${props.section}q-${props.count}`} className="row question border my-3">
      <div className="question-statement">
        <Image
          loading="lazy"
          src={`/${props.subject}/${props.section}q-${props.count}.png`}
          fluid={true}
        />
      </div>

      <div className="options-container">
        <div className="options col">
          <Form.Check
            type={'radio'}
            label={'Unattempted'}
            value={'u'}
            name={`${props.section}q-${props.count}`}
            defaultChecked
          >
          </Form.Check>
        </div>

        <div className="options col">
          <Form.Check
            type={'radio'}
            label={'Correct'}
            value={'c'}
            name={`${props.section}q-${props.count}`}
          >
          </Form.Check>
        </div>

        <div className="options col">
          <Form.Check
            type={'radio'}
            label={'Wrong'}
            value={'w'}
            name={`${props.section}q-${props.count}`}
          >
          </Form.Check>
        </div>
      </div>
    </div>
  );
}

export { MathSection, LogicalSection, ComputerSection, EnglishSection };
